import { createReducer, on } from '@ngrx/store';

import { OrderAnalysicModel } from '@app/models/myoffice/order/order-analysic.model';
import { OrderAnalysisState } from '@app/selectors/myoffice/order/order-analysis.selector';
import { orderAnalysicByMonthSuccess, orderAnalysicByRankSuccess, orderAnalysicByAgeSuccess, orderAnalysicByCateSuccess, orderAnalysicByProductSuccess } from '@app/actions/myoffice/order/order-analysis.action';

export const orderAnalysisFeatureKey = 'orderAnalysis';

export const initialState: OrderAnalysisState = {
  itemsByRank: [] as OrderAnalysicModel[],
  itemsByAge: [] as OrderAnalysicModel[],
  itemByMonth:{} as OrderAnalysicModel,
  itemsByCate: [] as OrderAnalysicModel[],
  itemsByProduct: [] as OrderAnalysicModel[],
}

export const orderAnalysisReducer = createReducer(
  initialState,
  on(orderAnalysicByRankSuccess, (state, { items }) => ({...state, itemsByRank: items})),
  on(orderAnalysicByAgeSuccess, (state, { items }) => ({...state, itemsByAge: items})),
  on(orderAnalysicByMonthSuccess, (state, { item }) => ({...state, itemByMonth: item})),
  on(orderAnalysicByCateSuccess, (state, { items }) => ({...state, itemsByCate: items})),
  on(orderAnalysicByProductSuccess, (state, { items }) => ({...state, itemsByProduct: items})),
);